
import * as _ from "lodash";
import "es6-promise";

import axios, { AxiosResponse } from "axios";
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";

import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import { WebAPI } from "../web-api";

@Component({
  props: {
    jobId: String,
  },
  filters: {},
})
export default class EventLog extends Vue {
  public events: any[] = [];
  public jobId: string;

  public submitting: boolean = false;

  created() {
    this.refresh();
  }

  public async refresh() {
    try {
      this.submitting = true;
      const response = await WebAPI.getJobEventLog(this.jobId);
      this.events = response.data.results;
      this.submitting = false;
    } catch (error) {
      console.log(error);
      this.submitting = false;
      this.$emit("refresh-error", error.toString());
      throw error;
    }
  }
}
